import { memo } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import Tag from '../../tag';

const useStyles = makeStyles(() => ({
  root: {
    wordBreak: 'break-word',
  },
}));

const VirtualItem = ({ item, isTag }) => {
  const classes = useStyles();

  if (isTag) {
    return (
      <div className={classes.root}>
        <Tag tag={item} color={item?.category?.color} />
      </div>
    );
  }

  return (
    <Typography variant="body1" className={classes.root}>
      {item.name || item.level}
    </Typography>
  );
};

VirtualItem.propTypes = {
  item: PropTypes.object.isRequired,
  isTag: PropTypes.bool.isRequired,
};

export default memo(VirtualItem);
